module.exports = __webpack_public_path__ + "media/images/bg/headers/bamboo-forest-left-5d0145e7f813faa2457ca0e4b9d90ee3.png";